<template>
    <span v-html="this.output"></span>
</template>

<script>
export default {
    props: {
        since: Number
    },
    data () {
        return {
            output: ''
        };
    },
    mounted () {
        this.setOutput();
        setInterval(this.setOutput, 1000);
    },
    methods: {
        setOutput () {
            let seconds = (Math.floor((new Date()) / 1000) - this.since);

            let hours = Math.floor(seconds / (60 * 60));

            let divisor_for_minutes = seconds % (60 * 60);
            let minutes = Math.floor(divisor_for_minutes / 60);

            let output = '';

            if (hours > 0) {
                output += hours + ' hour';

                if (hours != 1) {
                    output += 's';
                }

                if (minutes > 0) {
                    output += ' ';
                }
            }

            // show 1 minute instead of 0 minutes
            if (minutes == 0) {
                minutes = 1;
                output += ' '; // continue the cludge
            }

            if (minutes > 0) {
                output += minutes + ' minute';

                if (minutes != 1) {
                    output += 's';
                }
            }

            this.output = output;
        }
    }
}
</script>
